<template>
  <div>
    <!-- <div
      style="position: fixed; top: 0px; left: 0px; width: 100%; height: 80px; background-color: #3458A4; z-index: 1030; cursor: pointer;"
      @click="goEvent()"
    >
      <img
        v-bind:src="getBannerImg()"
        style="position: absolute; top: 0px; left: calc((100% - 700px)/2);"
      />
    </div> -->
    <div>
      <div
        style="position:absolute; left:0px; top:0px; position: absolute; z-index: -1;
      background-image: url('/img/img_main_home.png');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        width: 100%;
        height: 940px;"
      ></div>
      <!-- <div
        style="position:absolute; left:0px; top:760px; position: absolute; z-index: -1;
      background-color: #111736;
        width: 100%;
        height: 1418px;"
      ></div> -->
      <div class="container" id="top">
        <div class="row" v-bind:style="{'margin-top': getTopMargin(), width: '100%', 'text-align': 'center'}">
          <div data-aos="fade-right" class="col-lg-6">
            <h1
              class="h1"
              style="
              text-align: right; 
              font-size: 6em;
              font-weight: 900;
              font-stretch: normal;
              font-style: normal;
              line-height: normal;
              text-transform: uppercase;
              margin-right: 20px;
              margin-left: 20px;
              color: #ffffff;"
            >{{$t('main_land')}}</h1>
          </div>
          <div data-aos="fade-left" class="col-lg-6" style="margin: auto;">
            <h5
              class="description"
              style="
            font-size: 1.2em;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #acacac;
            "
            >{{$t(`land_desc`)}}</h5>
          </div>
        </div>
        <div style="width: 600px; display: flex; margin: -20px auto;">
          <div
            style="width: 270px; height: 68px; background-image: url('/img/btn_270.png'); font-size: 1.0em;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            margin-right: 20px;
            color: #fff568; padding-top: 23px;"
            @click="goHomepage()"
            class="btn"
          >{{$t('main_about')}}</div>
          <div
            style="width: 270px; height: 68px; background-image: url('/img/btn_270.png'); font-size: 1.0em;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            margin-left: 20px;
            color: #fff568; padding-top: 23px;"
            @click="goLand()"
            class="btn"
          >{{$t('main_about_land')}}</div>
        </div>

        <div v-if="!$store.state.account.mainsaleStarted" data-aos="fade-right" class="col-lg-12" style="text-align: center; margin-top: 40px;">
            <h5
              class="description"
              style="
            font-size: 22px;
            font-weight: 700;
            text-align: center;
            color: #fff568;
            "
            >{{$t(`mainsale_pre_desc_1`)}}</h5>
            <h5
              class="description"
              style="
              margin-top: -10px; 
            font-size: 22px;
            font-weight: 700;
            text-align: center;
            color: #fff568;
            "
            >{{$t(`mainsale_pre_desc_2`)}}</h5>
          </div>

        <div v-if="!$store.state.account.mainsaleStarted" class="row" style="margin-top: 40px; height: 345px; background-image: url('/img/bg_main_deco.png'); background-size: cover; background-position: center center;">
        <!-- <div v-if="!$store.state.account.mainsaleStarted" class="row"> -->
          <!-- <div data-aos="fade-right" class="col-lg-12" style="text-align: center; margin-top: -35px;">
            <h1
              class="h1"
              style="
            font-size: 3em;
            font-weight: 900;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            text-shadow: 2px 2px #000000;
            color: #ffffff;
            "
            >{{$t('2nd Pre-sale D-Day')}}</h1>
          </div> -->
          <div data-aos="fade-right" class="col-lg-12" style="text-align: center; margin-top: 20px;">
            <h5
              class="description"
              style="
            font-size: 1.2em;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #999999;
            "
            >{{$t(`mainsale_period_1`)}}</h5>
            <h5
              class="description"
              style="
              margin-top: -10px; 
            font-size: 1.2em;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #999999;
            "
            >{{$t(`mainsale_period_2`)}}</h5>
          </div>
          <!-- <div class="col-lg-12" style="text-align: center; margin-top: 60px;">
            <h5
              class="description"
              style="
            font-size: 20px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #ffffff;
            ">
            {{$t('Cumulative Reward')}}: {{totalReward.toFixed(4)}} DAI</h5>
            <h5
              class="description"
              style="
              margin-top: 0px; 
            font-size: 20px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #ffffff;
            "
            >{{$t('24H Reward')}}: {{todayReward.toFixed(4)}} DAI</h5>
          </div> -->
          <div class="col-lg-12" style="margin-top: 50px;">
            <flip-countdown deadline="2021-01-13 00:00:00.000Z"
            v-bind:labels=labels 
            ></flip-countdown>
          </div>
          <div style="width: 600px; display: flex; justify-content: center; margin: 40px auto;">
            <!-- <div
            @click="goToPresale()"
              style="width: 449px; height: 117px; background-image: url('/img/1st_sale/btn_presale.png'); font-size: 26px;
              font-weight: 600;
              text-align: center;
              cursor: pointer;
              color: #ffffff; padding-top: 35px;"
            >{{$t('preview_presale')}}</div> -->
            <div
            @click="goMainsale()"
              style="width: 440px; height: 112px; background-image: url('/img/btn_440.png'); font-size: 24px;
              font-weight: 600;
              text-align: center;
              cursor: pointer;
              color: #fff568; padding-top: 35px;"
            >{{$t('about main sale')}}</div>
          </div>
        </div>

        <div class="row" v-if="$store.state.account.mainsaleStarted" style="margin-top: 30px; height: 345px; background-image: url('/img/bg_main_deco.png'); background-size: cover; background-position: center center;">
          <div v-if="rate < 1" data-aos="fade-right" class="col-lg-12" style="text-align: center; margin-top: 20px;">
            <h5
              class="description"
              style="
            font-size: 1.2em;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #fff568;
            "
            >{{$t(`home_presale_start_1`)}}</h5>
            <h5
              class="description"
              style="
              margin-top: -10px; 
            font-size: 1.2em;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #fff568;
            "
            >{{$t(`home_presale_start_2`)}}</h5>
          </div>
          <div  v-else data-aos="fade-right" class="col-lg-12" style="text-align: center; margin-top: 20px; padding-top: 20px; height: 68px;">
            <h5
              class="description"
              style="
            font-size: 1.2em;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #fff568;
            "
            >{{$t(`info_presale1st_soldout`)}}</h5>
          </div>
          <div class="col-lg-12" style="margin-top: 50px;">
            <flip-countdown deadline="2020-06-18 23:59:59.999Z"
            v-bind:labels=labels 
            ></flip-countdown>
          </div>
          <div data-aos="fade-right" class="col-lg-12" style="text-align: center; margin-top: 20px;">
            <h5
              class="description"
              style="
            font-size: 1.2em;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #ffffff;
            "
            >{{$t(`sold_lands`)}}</h5>
          </div>
          <div data-aos="fade-right" class="col-lg-12" style="text-align: center; margin-top: 0px;">
            <div v-bind:style="{position: 'relative', 'background-image': `url('/img/1st_sale/bg_gauge.png')`, width: `518px`, height: '30px', margin: 'auto'}">
              <div v-bind:style="{position: 'absoulte', left: '0px', top: '0px', 'background-image': `url('/img/1st_sale/gauge.png')`, width: `${rate * 100}%`, height: '30px'}">               
              </div>
              <h5 style="position: absolute; left: 0px; top: 0px; width: 100%; height: 100%; padding-top: 3px; font-size: 16px; color: #fff568; font-weight: 900; -webkit-text-stroke: 1px #000;">{{$t('sold_rate', [(rate * 100).toFixed(2)])}}</h5>
            </div>
          </div>
          <div style="width: 600px; display: flex; justify-content: space-between; margin: 40px auto;">
            <div
            @click="goToPresale()"
              style="width: 449px; height: 80px; background-image: url('/img/1st_sale/btn_presale.png'); background-size: 100% 100%; font-size: 26px;
              font-weight: 600;
              text-align: center;
              cursor: pointer;
              color: #ffffff; padding-top: 18px;"
            >{{$t('join_presale')}}</div>
            <div
            @click="goPresale()"
              style="width: 126px; height: 80px; background-image: url('/img/1st_sale/btn_126.png'); background-size: 100% 100%;  font-size: 18px;
              font-weight: 600;
              text-align: center;
              cursor: pointer;
              color: #ffffff; padding-top: 12px;"
            >{{$t('main_about_pre-sale')}}</div>
          </div>
        </div>

        <div class="container" id="top2" v-bind:style="{'margin-top': getTopMargin2()}">
          <!-- <div style="margin-top: 40px;">
            <img v-bind:src="`/img/text_presale_p1_${localeString}_soldout.png`" />
          </div>

          <div style="margin-top: 40px;">
            <img v-bind:src="`img/text_presale_p2_${localeString}.png`" />
          </div>

          <div style="margin-top: 40px;">
            <img v-bind:src="`img/text_presale_m_${localeString}.png`" />
          </div> -->

          <div style="margin-top: 80px;">
            <img src="/img/img_deco_1.png" />
          </div>

          <div class="row" style="margin-top: 30px; width: 100%;">
            <div
              data-aos="fade-right"
              data-aos-offset="-200"
              class="col-lg-8"
              style="text-align: center; margin: auto;"
            >
              <h5
                class="description"
                style="
            font-size: 1.2em;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #000;
            "
              >{{$t(`presale_desc3`)}}</h5>
              <h5
                class="description"
                style="
            font-size: 1.2em;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #000;
            "
              >{{$t(`presale_desc4`)}}</h5>
            </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="text-center col-md-12 col-lg-12">
              <div class="row" style="padding-bottom: 0px;">
                <div
                  data-aos="fade-right"
                  data-aos-offset="-300"
                  class="col-md-6"
                  style="padding: 0;"
                >
                  <img v-lazy="'/img/img_sale_1.png'" width="100%" height="100%" />
                </div>
                <div
                  data-aos="fade-left"
                  data-aos-offset="-300"
                  class="col-md-6"
                  style="background-image: url('/img/bg_sale.png'); min-height: 220px; background-size: cover; background-repeat: no-repeat;"
                >
                  <h5
                    class="description-game-title text-left"
                    style="padding-left: 20px; padding-top:60px; color: black;"
                  >
                    <img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px;" />
                    {{$t(`presale_feature_title1`)}}
                  </h5>
                  <h5
                    class="description-game-desc text-left"
                    style="padding-left: 20px; padding-top:20px; color: black;"
                  >{{$t(`presale_feature_desc1`)}}</h5>
                </div>
              </div>
              <div class="row" style="margin-top: -20px;">
                <div
                  data-aos="fade-right"
                  data-aos-offset="-500"
                  class="col-md-6"
                  style="padding: 0;"
                >
                  <img v-lazy="'/img/img_sale_2.png'" width="100%" height="100%" />
                </div>
                <div
                  data-aos="fade-left"
                  data-aos-offset="-500"
                  class="col-md-6"
                  style="background-image: url('/img/bg_sale.png'); min-height: 220px; background-size: cover; background-repeat: no-repeat;"
                >
                  <h5
                    class="description-game-title text-left"
                    style="padding-left: 20px; padding-top:60px;"
                  >
                    <img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px; color: black;" />
                    {{$t(`presale_feature_title2`)}}
                  </h5>
                  <h5
                    class="description-game-desc text-left"
                    style="padding-left: 20px; padding-top:20px; color: black;"
                  >{{$t(`presale_feature_desc2`)}}</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-12 col-lg-12"
              style="margin-top: 20px; width: 100%; height: 176px; background-image: url('/img/bg_notice.png')"
            >
              <div style="padding-left: 160px; padding-top: 25px; height: 100%;">
                <h6
                  class="description"
                  style="
              font-size: 1.0em;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: normal;
              text-align: left;
              color: #f24922;
              "
                >
                  {{$t(`presale_warn1`)}}
                  <br />
                  <br />
                  {{$t(`presale_warn2`)}}
                  <br />
                  <br />
                  {{$t(`presale_warn3`)}}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button } from "@/components";
import { Popover } from "element-ui";
import FlipCountdown from "vue2-flip-countdown";
import config from "../config.js";
import axios from "axios";

export default {
  name: "index",
  bodyClass: "index-page",
  components: {
    [Button.name]: Button,
    [Popover.name]: Popover,
    //Parallax,
    FlipCountdown
  },
  computed: {
    localeString() {
      if (this.$i18n.locale == "ko") {
        return "kr";
      } else if (this.$i18n.locale == "ch-zn") {
        return "cn";
      } else if (this.$i18n.locale == "ja") {
        return "jp";
      } else {
        return "en";
      }
    }
  },
  methods: {
    getTopMargin() {
      if (this.$store.state.account.mainsaleStarted) {
        return "60px";
      }
      else {
        return "140px";
      }
    },
    getTopMargin2() {
      if (this.$store.state.account.mainsaleStarted) {
        return "160px";
      }
      else {
        return "240px";
      }
    },
    goToPresale() {
      this.$router.push("/presale");
    },
    goHomepage: async function() {
      let url = "//www.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goEvent() {
      this.$router.push("/event");
    },
    goLand: async function() {
      let url = "//link.medium.com/MPlz8qSaAcb";
      if (this.$i18n.locale == "ko") {
        url = "//link.medium.com/6DQiGKUaAcb";
      }
      window.open(url, "_blank");
    },
    goPresale: async function() {
      let url = "//link.medium.com/xN16Bo1Mp6";
      if (this.$i18n.locale == "ko") {
        url = "//link.medium.com/2l6xPJqKo6";
      } else if (this.$i18n.locale == "ch-zn") {
        //url = "//bihu.com/article/1016823935";
      }
      window.open(url, "_blank");
    },
    goMainsale: async function() {
      this.$router.push("/mainsale");
    },
    getBannerImg() {
      if (this.$i18n.locale == "ko") {
        return "/img/event/banner_event_kr.png";
      } else if (this.$i18n.locale == "ja") {
        return "/img/event/banner_event_jp.png";
      } else if (this.$i18n.locale == "ch-zn") {
        return "/img/event/banner_event_cn.png";
      } else {
        return "/img/event/banner_event_en.png";
      }
    },
    loadLandSaleInfo: async function(zoneId, refresh) {
      let round = "pre2";

      let ret = await axios.post(`${config.api.nft_url}/presale/lands`, {
        round: round,
        zoneId: zoneId,
        refresh: refresh
      });

      console.log('ret - ', ret);

      let isStarted = ret.data.isStarted;
      this.$store.commit('setPresaleStarted', isStarted);
      let products = ret.data.landSale.sale;
      let total = 0;
      let remain = 0;
      for (let i = 0; i < products.length; ++i) {
        let product = products[i];
        total += product.priceUSD * product.total;
        remain += product.priceUSD * product.remain;
      }
      if (total == 0) {
        this.rate = 0;
      }
      else {
        this.rate = (total - remain) / total;
        if (this.rate > 1) {
          this.rate = 1.0;
        }
      }      
    },
    getLandLordDashboard: async function() {
      let round = "pre2";

      let ret = await axios.post(`${config.api.nft_url}/landlord/dashboard`, {});

      console.log('ret - ', ret);

      this.totalReward = ret.data.total;
      this.todayReward = ret.data.today;
    },
  },
  mounted: async function() {
    await this.getLandLordDashboard(null, null);
    // this.timerId = setInterval(async () => {
    //   await this.loadLandSaleInfo(null, true);
    // }, 5 * 1000);
  },
  beforeDestroy: function() {
    if (this.timerId != null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  },
  data: function() {
    return {
      timerId: null,
      rate: 0,
      labels: {
        days: this.$t("Days"),
        hours: this.$t("Hours"),
        minutes: this.$t("Minutes"),
        seconds: this.$t("Seconds")
      },
      totalReward: 0,
      todayReward: 0
    };
  }
};
</script>
<style>
</style>
